import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { Strings } from '@app/constants';
import { useTable } from '@app/components/table';
import { Header } from '@app/sections/header';
import { AddRoleDialog } from './add-role/add-role-dialog';
import RoleList from './roles-list';
import { getRole } from '../slice';
import { useDialog, useRequestState, useSearch } from '@app/hooks';
import { selectRoleState } from '../selectors';
import { useAuthRolePermissions } from '@app/utils';

const RoleListPage = () => {
  const tableProps = useTable();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getRole());
  }, [dispatch]);

  const { data, loading } = useRequestState({
    stateSelector: selectRoleState,
    errorShown: true,
  });

  const addRoleDialog = useDialog();
  const searchProps = useSearch({ data: data?.records, fields: ['name', 'id'] });
  const { hasPermission } = useAuthRolePermissions();
  const canAddRoles = hasPermission('Roles', 'w');
  return (
    <>
      <Header
        title={Strings.role.roles}
        actionButtonTitle={canAddRoles ? Strings.button.addRole : undefined}
        onClickActionButton={addRoleDialog.show}
        searchBarProps={{
          placeholder: Strings.common.search,
          onChange: searchProps.handleSearchChange,
        }}
      />
      {addRoleDialog.visible && (
        <AddRoleDialog open={addRoleDialog.visible} onClose={addRoleDialog.hide} />
      )}
      <RoleList
        loading={loading}
        tableProps={tableProps}
        rows={searchProps.filteredRows}
        canAddRoles={canAddRoles}
      />
    </>
  );
};

export { RoleListPage };
